export const getContentVariant = ({ controls, description, disableDescription, }) => {
    const showDescription = Boolean(!disableDescription && description);
    const filteredControls = (controls === null || controls === void 0 ? void 0 : controls.filter(Boolean)) || [];
    const showControls = (filteredControls === null || filteredControls === void 0 ? void 0 : filteredControls.length) > 0;
    const showContent = showDescription || showControls;
    return {
        filteredControls,
        showContent,
        showControls,
        showDescription,
    };
};
//# sourceMappingURL=getContentVariant.js.map